import { useEffect } from "react";

export const Seo = ({ title, description }) => {
    useEffect(() => {
        document.title = title;
        const meta = document.querySelector('meta[name="description"]');
        if (meta) meta.setAttribute("content", description);
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical) {
            canonical.setAttribute(
                "href",
                `https://express-terms.preview.emergentagent.com${window.location.pathname}`
            );
        }
    }, [title, description]);
    return null;
};

export default Seo;
